import styled from 'styled-components';

export const CofidisContainer = styled.div`
    background-color: white;
    border-radius: 5px;
    border: 1px solid rgb(198, 198, 198);
    box-shadow: rgba(198, 198, 198, 0.282) 0px 0px 0px;
    display: flex;
    flex-wrap: nowrap;
    -moz-box-pack: justify;
    justify-content: space-between;
    padding: 20px;
    cursor: pointer;
    flex-direction: column;
    transition: all 200ms ease 0s;

    .text {
        display: flex;
        justify-content: space-between;

        label {
            padding-left: 0px;
        }

        .vertical-centre {
            padding: 5px;
            position: relative;
            top: -20%;
        }
    }

    .iframeContainer {
        padding-top: 30px;

        #EFSimulation {
            iframe {
                height: 290px;
            }
        }

        #EFConsent {
            iframe {
                height: 100px;
            }
        }
    }

    .btn-choice {
        background-color: white;
        color: ${props => props.theme.primary};
        margin-right: 3px;
        margin-left: 3px;
        border-radius: 999px;
        height: 25px;
        width: 25px;
        transition: all 0.2s;
    }
    .btn-choice:hover {
        background-color: ${props => props.theme.primary};
        color: white;
    }

    @media (max-width: ${props => props.theme.medium}) {
        .text {
            flex-direction: column;
            align-items: flex-start;
        }

        .text-choice {
            margin-top: 10px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/funnel/payment-selection-step/payment-choice/CofidisStyle.js